export default __webpack_public_path__ + "static/media/confusionImg_3.5bb75b5b.webp";